import script from "./GeneEqtlSummaries.vue?vue&type=script&lang=js"
export * from "./GeneEqtlSummaries.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__